<script>
  export let text = "";
  export let handleClick = () => {};
  export let clickable = false;
  export let disable = false;
</script>

<!-- svelte-ignore a11y-click-events-have-key-events -->
<div
  class="badge {clickable ? 'clickable' : ''} {disable ? 'disable' : ''}"
  on:click={() => {
    if (clickable) handleClick();
  }}
>
  <span class="badge-text" title={text}>{text}</span>
  <button
    type="button"
    class="badge-button"
    aria-label="Remove"
    on:click={(e) => {
      e.stopPropagation();
      handleClick();
    }}
  >
    <svg
      width="13"
      height="13"
      class="icon-small"
      aria-hidden="true"
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 14 14"
    >
      <path
        stroke="currentColor"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="0.5"
        d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6"
      />
    </svg>
  </button>
</div>

<style>
  .badge {
    display: inline-flex;
    align-items: center;
    padding: 7px 12px;
    margin: 6px 8px;
    background-color: var(--pax-black);
    color: var(--pax-white);
    border-radius: 9999px;
    font-size: 12px;
  }

  .badge-text {
    display: inline-block;
    max-width: 100px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .badge-button {
    display: inline-flex;
    align-items: center;
    margin-left: 6px;
    color: var(--pax-white);
    background-color: transparent;
    transition:
      background-color 0.3s,
      color 0.3s;
  }

  .badge-button:hover {
    scale: 1.2;
    color: white;
  }

  .clickable {
    cursor: pointer;
  }

  .disable {
    background-color: var(--pax-black-inactive);
  }
</style>
